/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import $$ from './storage';

var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, state) {
    var st = state;
    var key = '';
    var storageKey = '';

    var _iterator = _createForOfIteratorHelper(mutation.type.split('/')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;

        if (type[0] === '_') {
          key = type.substring(1);
          st = st[key];
          storageKey += key;
        } else {
          st = st[type];
          storageKey += type + '/';
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    $$.set(storageKey, st);
  });
};

export default [localStoragePlugin];